"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "UseWorker", {
    enumerable: true,
    get: function() {
        return UseWorker;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _nanoid = require("nanoid");
const _Jobs = require("~/interface/Jobs");
const _pubsubredis = require("~/redis/pubsub-redis");
const nanoidv2 = (0, _nanoid.customAlphabet)('1234567890abcdefghijklmnopqrstuvwxyz', 14);
const logger = new _common.Logger('UseWorker');
function UseWorker() {
    const injectJobsService = (0, _common.Inject)('JobsService');
    return (target, key, descriptor)=>{
        if (!_pubsubredis.PubSubRedis.available) return descriptor;
        if (process.env.NC_WORKER_CONTAINER !== 'false') return descriptor;
        injectJobsService(target, 'jobsService');
        const service = target.constructor.name;
        const method = key.toString();
        descriptor.value = async function(...args) {
            args = args.map((arg)=>{
                if (typeof arg === 'function') {
                    logger.error('Function passed as argument to UseWorker decorator, only JSON serializable data is allowed');
                    return;
                }
                if (typeof arg === 'object') {
                    try {
                        return JSON.parse(JSON.stringify(arg, (0, _nocodbsdk.getCircularReplacer)()));
                    } catch (e) {
                        logger.error(e);
                        return;
                    }
                }
                return arg;
            });
            const jobService = this.jobsService;
            const jobId = `job${nanoidv2()}`;
            return await new Promise((resolve, reject)=>{
                _pubsubredis.PubSubRedis.subscribe(`worker:job:${jobId}`, async (data, unsubscribe)=>{
                    if (data.success) {
                        resolve(data.result);
                    } else {
                        reject(data.error);
                    }
                    await unsubscribe();
                }).then(()=>{
                    jobService.add(_Jobs.JobTypes.UseWorker, {
                        service,
                        method,
                        args
                    }, {
                        jobId
                    }).catch((e)=>{
                        logger.error(e);
                    });
                }).catch((e)=>{
                    logger.error(e);
                    reject(e);
                });
            });
        };
        return descriptor;
    };
}
